import {FaTrash} from "react-icons/fa";
import {FaPencil} from "react-icons/fa6";
import {
  requestAddAddrresses,
  requestAddrresses,
  requestDeleteAddrress,
  requestUpdateAddrress,
} from "../../../redux/Actions/address.actions";

export const addressActions = {
  load: requestAddrresses,
  create: requestAddAddrresses,
  update: requestUpdateAddrress,
  delete: requestDeleteAddrress,
};

export const LIST_HEADERS = [
  "address",
  "city",
  "state",
  "country",
  "zip_code",
  "is_mailing",
  "is_billing",
  "is_shipping",
];

export const useActionsList = () => {
  return [
    {
      label: "Edit",
      icon: FaPencil,
      perms: ["change_organizationaddress"],
    },
    {
      label: "Delete",
      icon: FaTrash,
      perms: ["delete_organizationaddress"],
    },
  ];
};

export const usePermsForActions = () => {
  return ["change_organizationaddress", "delete_organizationaddress"];
};
